const linkResolver = doc => {
    console.log("doc", doc)

    if (doc.type === "mainpage") {
        return "/"
    }

    if (doc.type === "page") {
        return `/${doc.uid}`
    }

    if (doc.type === "project") {
        return `/${doc.uid}`
    }

    return "/"
}

module.exports = linkResolver
